export const sessions = [
  {
    workoutId: 1,
    title: '⚡ Lightning Fast Feet',
    description: 'Move your feet super fast like lightning',
    duration: '7 Min',
    exercises: [4, 7, 8, 9, 10], // Fast Feet, High Knees, Mountain Climbers, Star Jumps, Skater Hops
    completion: {
      points: 63,
    },
  },
  {
    workoutId: 2,
    title: '💃 Ball Dancing Fun',
    description: 'Dance and move with fun ball exercises',
    duration: '7 Min',
    exercises: [11, 12, 9, 13, 14], // One Leg Stand, Side Lunges, Star Jumps, Big Arm Swings, Rainbow Reaches
    completion: {
      points: 22,
    },
  },
  {
    workoutId: 3,
    title: '💪 Super Shot Power',
    description: 'Build super strong shooting power',
    duration: '7 Min',
    exercises: [15, 16, 9, 17, 18], // Frog Jumps, Mini Squats, Star Jumps, Burpees, Tiger Pounces
    completion: {
      points: 24,
    },
  },
  {
    workoutId: 4,
    title: '🦾 Upper Body Strength',
    description: 'Make your arms and chest super strong',
    duration: '8 Min',
    exercises: [23, 24, 26, 25, 27], // Plank, Push-ups, Wall Sits, Superman Holds, Bridge Holds
    completion: {
      points: 55,
    },
  },
  {
    workoutId: 5,
    title: '🦘 Bouncy Kangaroo Moves',
    description: 'Jump and bounce like a kangaroo',
    duration: '6 Min',
    exercises: [22, 12, 8, 4, 11], // Rabbit Hops, Side Lunges, Mountain Climbers, Fast Feet, One Leg Stand
    completion: {
      points: 20,
    },
  },
  {
    workoutId: 6,
    title: '⭐ Superhero Training',
    description: 'Train like a superhero with amazing moves',
    duration: '7 Min',
    exercises: [23, 26, 27, 8, 17], // Plank, Wall Sits, Bridge Holds, Mountain Climbers, Burpees
    completion: {
      points: 30,
    },
  },
  {
    workoutId: 7,
    title: '🛡️ Core Power Builder',
    description: 'Build a super strong core and tummy',
    duration: '7 Min',
    exercises: [23, 25, 27, 24, 11], // Plank, Superman Holds, Bridge Holds, Push-ups, One Leg Stand
    completion: {
      points: 23,
    },
  },
  {
    workoutId: 8,
    title: '🏃‍♀️ Endurance Runner',
    description: 'Build endurance to run longer and faster',
    duration: '7 Min',
    exercises: [7, 4, 8, 26, 9], // High Knees, Fast Feet, Mountain Climbers, Wall Sits, Star Jumps
    completion: {
      points: 26,
    },
  },
  {
    workoutId: 9,
    title: '🐻 Animal Moves',
    description: 'Move like different animals',
    duration: '6 Min',
    exercises: [19, 20, 18, 21, 22], // Bear Crawl, Crab Walk, Tiger Pounces, Zebra Gallops, Rabbit Hops
    completion: {
      points: 21,
    },
  },
  {
    workoutId: 10,
    title: '🌟 Balance Master',
    description: 'Master balance and coordination',
    duration: '7 Min',
    exercises: [11, 13, 14, 23, 25], // One Leg Stand, Big Arm Swings, Rainbow Reaches, Plank, Superman Holds
    completion: {
      points: 19,
    },
  },
  {
    workoutId: 11,
    title: '🚀 Explosive Power',
    description: 'Build explosive power and speed',
    duration: '6 Min',
    exercises: [15, 9, 17, 18, 21], // Frog Jumps, Star Jumps, Burpees, Tiger Pounces, Zebra Gallops
    completion: {
      points: 27,
    },
  },
  {
    workoutId: 12,
    title: '🎯 Precision Training',
    description: 'Practice balance, lunges, and core holds with precision',
    duration: '7 Min',
    exercises: [11, 12, 23, 26, 27], // One Leg Stand, Side Lunges, Plank, Wall Sits, Bridge Holds
    completion: {
      points: 25,
    },
  },
  {
    workoutId: 13,
    title: '🔥 Fire Starter',
    description:
      'Get your heart pumping with fast feet, high knees, and jumping moves',
    duration: '6 Min',
    exercises: [4, 7, 8, 9, 10], // Fast Feet, High Knees, Mountain Climbers, Star Jumps, Skater Hops
    completion: {
      points: 20,
    },
  },
  {
    workoutId: 14,
    title: '💫 Flexibility Fun',
    description: 'Improve flexibility with balance poses and arm movements',
    duration: '7 Min',
    exercises: [11, 13, 14, 23, 25], // One Leg Stand, Big Arm Swings, Rainbow Reaches, Plank, Superman Holds
    completion: {
      points: 18,
    },
  },
  {
    workoutId: 15,
    title: '⚔️ Warrior Training',
    description:
      'Build warrior strength with planks, push-ups, and powerful moves',
    duration: '8 Min',
    exercises: [23, 24, 26, 27, 17], // Plank, Push-ups, Wall Sits, Bridge Holds, Burpees
    completion: {
      points: 35,
    },
  },
  {
    workoutId: 16,
    title: '🎪 Circus Star',
    description: 'Perform circus moves with balance, jumps, and animal poses',
    duration: '7 Min',
    exercises: [11, 12, 15, 18, 21], // One Leg Stand, Side Lunges, Frog Jumps, Tiger Pounces, Zebra Gallops
    completion: {
      points: 22,
    },
  },
  // NEW ADVANCED WORKOUTS
  {
    workoutId: 17,
    title: '🔥 Elite Power Training',
    description:
      'Build elite power with jump squats, tuck jumps, and advanced push-ups',
    duration: '10 Min',
    exercises: [35, 36, 40, 41, 42], // Jump Squats, Tuck Jumps, Diamond Push-ups, Pike Push-ups, Single Leg Squats
    completion: {
      points: 45,
    },
  },
  {
    workoutId: 18,
    title: '🏃‍♂️ Athletic Beast Mode',
    description:
      'Train like a beast with sprints, split jumps, and intense moves',
    duration: '12 Min',
    exercises: [39, 37, 34, 46, 38], // Sprint Intervals, Split Jumps, Mountain Climber Burpees, Thrusters, Step Jumps
    completion: {
      points: 52,
    },
  },
  {
    workoutId: 19,
    title: '⭐ Pro Athlete Prep',
    description:
      'Prepare like a pro with L-sits, dragon walks, and explosive moves',
    duration: '11 Min',
    exercises: [43, 45, 35, 40, 39], // L-Sit Hold, Dragon Walk, Jump Squats, Diamond Push-ups, Sprint Intervals
    completion: {
      points: 48,
    },
  },
  {
    workoutId: 20,
    title: "🏆 Champion's Challenge",
    description:
      'Face the champion challenge with thrusters, split jumps, and advanced moves',
    duration: '13 Min',
    exercises: [46, 37, 41, 42, 44], // Thrusters, Split Jumps, Pike Push-ups, Single Leg Squats, Single Leg Deadlifts
    completion: {
      points: 55,
    },
  },
  // NEW INTERMEDIATE WORKOUTS
  {
    workoutId: 21,
    title: '💪 Strength Builder Plus',
    description:
      'Build strength with push-ups, wall sits, and upper body moves',
    duration: '9 Min',
    exercises: [24, 26, 27, 28, 30], // Push-ups, Wall Sits, Bridge Holds, Upper Cuts, Tricep Dips
    completion: {
      points: 38,
    },
  },
  {
    workoutId: 22,
    title: '🏃‍♀️ Cardio Crusher',
    description:
      'Crush cardio with fast feet, mountain climbers, and jumping moves',
    duration: '8 Min',
    exercises: [4, 8, 10, 15, 21], // Fast Feet, Mountain Climbers, Skater Hops, Frog Jumps, Zebra Gallops
    completion: {
      points: 35,
    },
  },
  {
    workoutId: 23,
    title: '⚖️ Balance & Coordination',
    description:
      'Improve balance and coordination with animal walks and lunges',
    duration: '8 Min',
    exercises: [11, 12, 19, 20, 31], // One Leg Stand, Side Lunges, Bear Crawl, Crab Walk, Inchworm Walk
    completion: {
      points: 32,
    },
  },
  {
    workoutId: 24,
    title: '🦾 Full Body Power',
    description:
      'Build full body power with planks, superman holds, and explosive moves',
    duration: '9 Min',
    exercises: [23, 25, 17, 18, 29], // Plank, Superman Holds, Burpees, Tiger Pounces, Tricep Dips
    completion: {
      points: 40,
    },
  },
  // NEW BEGINNER WORKOUTS
  {
    workoutId: 25,
    title: '🏃‍♂️ Fitness Foundations',
    description:
      'Build fitness foundations with high knees, star jumps, and basic moves',
    duration: '6 Min',
    exercises: [7, 9, 13, 16, 32], // High Knees, Star Jumps, Big Arm Swings, Mini Squats, Arm Circles
    completion: {
      points: 18,
    },
  },
  {
    workoutId: 26,
    title: '🔆 Active Start',
    description:
      'Start your day active with rabbit hops, rainbow reaches, and fun moves',
    duration: '5 Min',
    exercises: [22, 14, 11, 33, 7], // Rabbit Hops, Rainbow Reaches, One Leg Stand, Jumping Jacks, High Knees
    completion: {
      points: 15,
    },
  },
  {
    workoutId: 27,
    title: '💪 Strength Basics',
    description:
      'Learn strength basics with squats, arm swings, and balance poses',
    duration: '6 Min',
    exercises: [16, 13, 32, 11, 14], // Mini Squats, Big Arm Swings, Arm Circles, One Leg Stand, Rainbow Reaches
    completion: {
      points: 16,
    },
  },
  {
    workoutId: 28,
    title: '🌟 Coordination Fun',
    description:
      'Have fun improving coordination with balance, reaches, and jumping moves',
    duration: '5 Min',
    exercises: [11, 14, 22, 9, 13], // One Leg Stand, Rainbow Reaches, Rabbit Hops, Star Jumps, Big Arm Swings
    completion: {
      points: 14,
    },
  },
];
